module.exports = __webpack_public_path__ + "static/media/alibaba_cloud.8a1d863a.svg";